/* =========================================================
   Forge — Alta al carrito sin recargar la página.

   El pedido era que elegir el pack no saque al cliente de la
   ficha. Se intercepta el submit del formulario, se agrega por
   fetch a /cart/add.js y se abre un panel lateral que confirma,
   muestra el subtotal y ofrece lo que falta para completar el
   equipo. Si el JS falla o está desactivado, el formulario se
   envía como siempre: nunca queda un botón muerto.

   BUG CORREGIDO (15/08/2026) — cajon del carrito desactualizado:
   al agregar desde la ficha se actualizaba el numerito del header
   pero NO el cajon lateral del tema, que seguía mostrando el HTML
   con el que se cargó la página. Reproducido: agregabas el
   cinturón, abrías el carrito y veías el KIT de una visita
   anterior con otro total. Un cliente veía un precio que no era.

   La causa: el cajon de Flora no escucha eventos sueltos, se
   redibuja con la Section Rendering API. Ahora, después de cada
   cambio, se pide el HTML fresco de esa sección y se reemplaza.

   23/08/2026 — tres ajustes por el acolchado y el KIT GYM:
   · missing() trata acolchado y palanca como "ya tiene cinturón".
     Antes, quien agregaba el acolchado de $1.990 no figuraba con
     cinturón y el panel le ofrecía el KIT de $4.399.
   · Los DOS packs cortan la sugerencia. Sin esto, a quien compraba
     el KIT GYM entero se le seguía ofreciendo el otro pack.
   · El pie decía "el mismo envío, que es gratis": el envío gratis
     es sólo de Montevideo. Ahora dice lo único que vale para todos
     — sumar una pieza no encarece el envío.
   ========================================================= */
(function () {
  'use strict';

  var cfgEl = document.querySelector('[data-forge-catalog]');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return; // Sin catálogo válido, dejamos el submit nativo.
  }
  if (!cfg || !cfg.items) return;

  var panel = document.querySelector('[data-fadd]');
  var lastFocus = null;

  /* ---------- Moneda ---------- */
  function group(value, decimals, thousands, decimal) {
    var s = Math.abs(value).toFixed(decimals);
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    return (value < 0 ? '-' : '') + out;
  }

  function money(cents) {
    var fmt = cfg.moneyFormat || '${{amount}}';
    var v = (cents || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(v, 0, ',', '.');
        case 'amount_with_comma_separator': return group(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(v, 0, '.', ',');
        case 'amount_with_space_separator': return group(v, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return group(v, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return group(v, 2, "'", '.');
        default: return group(v, 2, ',', '.');
      }
    });
  }

  /* ---------- Cajon lateral del tema ----------
     Se busca la seccion por su id real en la pagina, para no
     depender de como se llame en cada tema. */
  function drawerSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id*="cart-drawer"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function refreshDrawer() {
    var id = drawerSectionId();
    if (!id) return Promise.resolve();
    return fetch('/?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        var host = document.getElementById('shopify-section-' + id);
        if (!html || !host) return;
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById('shopify-section-' + id);
        if (fresh) host.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* si falla, el numerito igual quedo bien */ });
  }

  /* ---------- Red ---------- */
  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
        return data;
      });
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function syncHeader(cart) {
    var nodes = document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text, cart-icon [data-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = cart.item_count;
    ['cart:refresh', 'cart:update', 'cart:change'].forEach(function (name) {
      document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { cart: cart } }));
    });
    return refreshDrawer();
  }

  /* ---------- Panel ---------- */
  function byRole(role) {
    for (var i = 0; i < cfg.items.length; i++) if (cfg.items[i].role === role) return cfg.items[i];
    return null;
  }

  function missing(cart) {
    var have = {};
    (cart.items || []).forEach(function (line) {
      cfg.items.forEach(function (c) { if (c.id === line.product_id) have[c.role] = true; });
    });

    // Cualquiera de los dos packs ya trae cinturon y straps: no falta nada.
    if (have.kit || have.kitgym) return [];

    // Palanca y acolchado cuentan igual: son dos cinturones. A quien ya
    // eligio uno no se le ofrece el otro — se le ofrece lo que le falta.
    var hasBelt = have.belt || have.acol;

    var out = [];
    if (hasBelt && !have.straps) out.push(byRole('straps'));
    else if (have.straps && !hasBelt) out.push(byRole('acol'));
    else if (!hasBelt && !have.straps) out.push(byRole('kitgym'));
    return out.filter(function (c) { return c && c.available; });
  }

  function rowHtml(item) {
    var img = item.image
      ? '<img src="' + item.image + '" alt="" loading="lazy" width="56" height="56">'
      : '<span></span>';
    var price = item.priceText + (item.compareText ? ' <s>' + item.compareText + '</s>' : '');
    var action = item.addable
      ? '<button type="button" data-fadd-add="' + item.variantId + '">Agregar</button>'
      : '<a class="fh-btn fh-btn--ghost" style="padding:.5rem .8rem;font-size:.78rem" href="' + item.url + '">Elegir talle</a>';
    return (
      '<div class="fadd__row">' + img +
      '<div><b>' + item.title + '</b><small>' + item.note + ' ' + price + '</small></div>' +
      action + '</div>'
    );
  }

  function render(cart, added) {
    if (!panel) return;

    var itemBox = panel.querySelector('[data-fadd-item]');
    if (itemBox && added) {
      var img = added.image
        ? '<img src="' + added.image + '" alt="" width="72" height="72">'
        : '<span></span>';
      var variant = added.variant_title && added.variant_title !== 'Default Title'
        ? 'Talle ' + added.variant_title + ' · '
        : '';
      itemBox.innerHTML =
        '<div class="fadd__item">' + img +
        '<div><b>' + added.product_title + '</b>' +
        '<span>' + variant + added.quantity + ' × ' + money(added.final_price) + '</span></div></div>';
    }

    var sub = panel.querySelector('[data-fadd-sub]');
    if (sub) sub.textContent = money(cart.total_price);

    var box = panel.querySelector('[data-fadd-upsell]');
    var rows = panel.querySelector('[data-fadd-rows]');
    var note = panel.querySelector('[data-fadd-upsell-note]');
    var falta = missing(cart);

    if (box && rows) {
      if (falta.length) {
        rows.innerHTML = falta.map(rowHtml).join('');
        if (note) {
          note.textContent = /^kit/.test(falta[0].role)
            ? 'El pack sale menos que las piezas por separado.'
            : 'Viaja en el mismo paquete: no encarece el envío.';
        }
        box.hidden = false;
      } else {
        box.hidden = true;
      }
    }
  }

  function open() {
    if (!panel) return;
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = panel.querySelector('[data-fadd-close]');
    if (close && close.focus) close.focus();
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showError(msg) {
    if (!panel) { window.alert(msg); return; }
    var err = panel.querySelector('[data-fadd-err]');
    if (err) { err.textContent = msg; err.hidden = false; }
  }

  function clearError() {
    if (!panel) return;
    var err = panel.querySelector('[data-fadd-err]');
    if (err) { err.textContent = ''; err.hidden = true; }
  }

  if (panel) {
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-fadd-close]')) { close(); return; }

      var addBtn = e.target.closest('[data-fadd-add]');
      if (addBtn) {
        var id = addBtn.getAttribute('data-fadd-add');
        addBtn.disabled = true;
        addBtn.textContent = 'Agregando…';
        clearError();
        addToCart(id, 1)
          .then(function () { return getCart(); })
          .then(function (cart) {
            render(cart, null);
            return syncHeader(cart);
          })
          .catch(function (err) {
            addBtn.disabled = false;
            addBtn.textContent = 'Agregar';
            showError(err.message);
          });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }

  /* ---------- Formulario de la ficha ---------- */
  var form = document.querySelector('.fp__form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    e.preventDefault();
    clearError();

    var btn = form.querySelector('.fp__add');
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = parseInt(qtyInput && qtyInput.value, 10);
    if (!qty || qty < 1) qty = 1;

    var label = btn ? btn.textContent : '';
    if (btn) { btn.classList.add('is-loading'); btn.textContent = 'Agregando…'; }

    addToCart(idInput.value, qty)
      .then(function (res) {
        var added = res.items ? res.items[0] : res;
        return getCart().then(function (cart) {
          render(cart, added);
          open();
          if (btn) {
            btn.classList.remove('is-loading');
            btn.classList.add('is-done');
            btn.textContent = 'Agregado ✓';
            setTimeout(function () {
              btn.classList.remove('is-done');
              btn.textContent = label;
            }, 1800);
          }
          return syncHeader(cart);
        });
      })
      .catch(function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.textContent = label; }
        showError(err.message);
        open();
      });
  });
})();
